import React from 'react';
import { StyleRoot } from 'radium';

export default function widthRadiumStyleRoot(Component) {
  return props => (<StyleRoot><Component {...props} /></StyleRoot>);
}



// WEBPACK FOOTER //
// ./src/components/withRadiumStyleRoot.js